module.exports = __webpack_public_path__ + "img/cww_07.f018c24d.jpg";